"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/legacy_portal_common.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalAddressInfo = exports.LegacyPortalShippingStatusEntry = exports.LegacyPortalShippingStatus = exports.LegacyPortalShippingStatusDeliveryCarrier = exports.LegacyPortalShippingStatusDispatchStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * 出荷ステータス
 *
 * @generated from enum spwn.shipping.v1.LegacyPortalShippingStatusDispatchStatus
 */
var LegacyPortalShippingStatusDispatchStatus;
(function (LegacyPortalShippingStatusDispatchStatus) {
    /**
     * 不明
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalShippingStatusDispatchStatus[LegacyPortalShippingStatusDispatchStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * キャンセル
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_CANCELLED = 1;
     */
    LegacyPortalShippingStatusDispatchStatus[LegacyPortalShippingStatusDispatchStatus["CANCELLED"] = 1] = "CANCELLED";
    /**
     * 出荷準備中
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_PACKING = 2;
     */
    LegacyPortalShippingStatusDispatchStatus[LegacyPortalShippingStatusDispatchStatus["PACKING"] = 2] = "PACKING";
    /**
     * 出荷済み
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_SHIPPED = 3;
     */
    LegacyPortalShippingStatusDispatchStatus[LegacyPortalShippingStatusDispatchStatus["SHIPPED"] = 3] = "SHIPPED";
})(LegacyPortalShippingStatusDispatchStatus || (exports.LegacyPortalShippingStatusDispatchStatus = LegacyPortalShippingStatusDispatchStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalShippingStatusDispatchStatus)
protobuf_1.proto3.util.setEnumType(LegacyPortalShippingStatusDispatchStatus, "spwn.shipping.v1.LegacyPortalShippingStatusDispatchStatus", [
    { no: 0, name: "LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_CANCELLED" },
    { no: 2, name: "LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_PACKING" },
    { no: 3, name: "LEGACY_PORTAL_SHIPPING_STATUS_DISPATCH_STATUS_SHIPPED" },
]);
/**
 * 配送業者
 *
 * @generated from enum spwn.shipping.v1.LegacyPortalShippingStatusDeliveryCarrier
 */
var LegacyPortalShippingStatusDeliveryCarrier;
(function (LegacyPortalShippingStatusDeliveryCarrier) {
    /**
     * 不明
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_UNSPECIFIED = 0;
     */
    LegacyPortalShippingStatusDeliveryCarrier[LegacyPortalShippingStatusDeliveryCarrier["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未指定
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_UNSELECTED = 1;
     */
    LegacyPortalShippingStatusDeliveryCarrier[LegacyPortalShippingStatusDeliveryCarrier["UNSELECTED"] = 1] = "UNSELECTED";
    /**
     * ヤマト運輸
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_YAMATO = 2;
     */
    LegacyPortalShippingStatusDeliveryCarrier[LegacyPortalShippingStatusDeliveryCarrier["YAMATO"] = 2] = "YAMATO";
    /**
     * 佐川急便
     *
     * @generated from enum value: LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_SAGAWA = 3;
     */
    LegacyPortalShippingStatusDeliveryCarrier[LegacyPortalShippingStatusDeliveryCarrier["SAGAWA"] = 3] = "SAGAWA";
})(LegacyPortalShippingStatusDeliveryCarrier || (exports.LegacyPortalShippingStatusDeliveryCarrier = LegacyPortalShippingStatusDeliveryCarrier = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalShippingStatusDeliveryCarrier)
protobuf_1.proto3.util.setEnumType(LegacyPortalShippingStatusDeliveryCarrier, "spwn.shipping.v1.LegacyPortalShippingStatusDeliveryCarrier", [
    { no: 0, name: "LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_UNSELECTED" },
    { no: 2, name: "LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_YAMATO" },
    { no: 3, name: "LEGACY_PORTAL_SHIPPING_STATUS_DELIVERY_CARRIER_SAGAWA" },
]);
/**
 * 配送状況情報
 *
 * @generated from message spwn.shipping.v1.LegacyPortalShippingStatus
 */
class LegacyPortalShippingStatus extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 出荷ステータス
         *
         * @generated from field: spwn.shipping.v1.LegacyPortalShippingStatusDispatchStatus status = 1;
         */
        this.status = LegacyPortalShippingStatusDispatchStatus.UNSPECIFIED;
        /**
         * 配送業者
         *
         * @generated from field: spwn.shipping.v1.LegacyPortalShippingStatusDeliveryCarrier delivery_carrier = 4;
         */
        this.deliveryCarrier = LegacyPortalShippingStatusDeliveryCarrier.UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalShippingStatus, a, b);
    }
}
exports.LegacyPortalShippingStatus = LegacyPortalShippingStatus;
LegacyPortalShippingStatus.runtime = protobuf_1.proto3;
LegacyPortalShippingStatus.typeName = "spwn.shipping.v1.LegacyPortalShippingStatus";
LegacyPortalShippingStatus.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalShippingStatusDispatchStatus) },
    { no: 2, name: "tracking_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "tracking_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "delivery_carrier", kind: "enum", T: protobuf_1.proto3.getEnumType(LegacyPortalShippingStatusDeliveryCarrier) },
]);
/**
 * 問い合わせキー1件分の配送状況
 *
 * @generated from message spwn.shipping.v1.LegacyPortalShippingStatusEntry
 */
class LegacyPortalShippingStatusEntry extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * この要素がリクエストのどのIDに対応するかを示すキー。解決できなかったIDは要素ごと返らないため、
         * 配列の順序ではリクエストと対応付けできない
         *
         * @generated from oneof spwn.shipping.v1.LegacyPortalShippingStatusEntry.shipping_key
         */
        this.shippingKey = { case: undefined };
        /**
         * 分割出荷では複数返る。SPWN注文は常に1件。配送情報がまだ無い場合は空
         *
         * @generated from field: repeated spwn.shipping.v1.LegacyPortalShippingStatus shipping_statuses = 3;
         */
        this.shippingStatuses = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalShippingStatusEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalShippingStatusEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalShippingStatusEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalShippingStatusEntry, a, b);
    }
}
exports.LegacyPortalShippingStatusEntry = LegacyPortalShippingStatusEntry;
LegacyPortalShippingStatusEntry.runtime = protobuf_1.proto3;
LegacyPortalShippingStatusEntry.typeName = "spwn.shipping.v1.LegacyPortalShippingStatusEntry";
LegacyPortalShippingStatusEntry.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fulfillment_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "shipping_key" },
    { no: 2, name: "shopify_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "shipping_key" },
    { no: 3, name: "shipping_statuses", kind: "message", T: LegacyPortalShippingStatus, repeated: true },
]);
/**
 * @generated from message spwn.shipping.v1.LegacyPortalAddressInfo
 */
class LegacyPortalAddressInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string zip_code = 1;
         */
        this.zipCode = "";
        /**
         * @generated from field: string prefecture = 2;
         */
        this.prefecture = "";
        /**
         * @generated from field: string city = 3;
         */
        this.city = "";
        /**
         * @generated from field: string street_num = 4;
         */
        this.streetNum = "";
        /**
         * @generated from field: string building_info = 5;
         */
        this.buildingInfo = "";
        /**
         * @generated from field: string phone = 6;
         */
        this.phone = "";
        /**
         * @generated from field: string recipient_name = 7;
         */
        this.recipientName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAddressInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAddressInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAddressInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAddressInfo, a, b);
    }
}
exports.LegacyPortalAddressInfo = LegacyPortalAddressInfo;
LegacyPortalAddressInfo.runtime = protobuf_1.proto3;
LegacyPortalAddressInfo.typeName = "spwn.shipping.v1.LegacyPortalAddressInfo";
LegacyPortalAddressInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "zip_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "street_num", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "building_info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "recipient_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map